import { render, staticRenderFns } from "./PacienteListagem.vue?vue&type=template&id=2d43199b&scoped=true"
import script from "./PacienteListagem.vue?vue&type=script&lang=js"
export * from "./PacienteListagem.vue?vue&type=script&lang=js"
import style0 from "./PacienteListagem.vue?vue&type=style&index=0&id=2d43199b&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d43199b",
  null
  
)

export default component.exports